<template>
	<div>
		<template v-if="switchFlag">
			<label class="topcoat-radio-button">
				<input :name="radioGroupName"
				       :class="{'is-danger': errors.has(radioGroupName) }"
				       type="radio"
				       v-model="picked"
				       v-validate="{ rules: { required: true, in:['yes'] } }"
				       value="yes">
				<div class="topcoat-radio-button__checkmark"
				     :class="{'is-danger': errors.has(radioGroupName) }"></div>
			</label>
			<label class="topcoat-radio-button">
				<input :name="radioGroupName" type="radio" v-model="picked" value="no">
				<div class="topcoat-radio-button__checkmark"
				     :class="{'is-danger': errors.has(radioGroupName) }"></div>
			</label>
		</template>
		<template v-else>
			<label class="topcoat-radio-button">
				<input :name="radioGroupName" type="radio" v-model="picked" value="no">
				<div class="topcoat-radio-button__checkmark"
				     :class="{'is-danger': errors.has(radioGroupName) }"></div>
			</label>
			<label class="topcoat-radio-button">
				<input :name="radioGroupName"
				       :class="{'is-danger': errors.has(radioGroupName) }"
				       type="radio"
				       v-model="picked"
				       v-validate="{ rules: { required: true, in:['yes'] } }"
				       value="yes">
				<div class="topcoat-radio-button__checkmark"
				     :class="{'is-danger': errors.has(radioGroupName) }"></div>
			</label>
		</template>

		<!--{{picked}}-->
		<span v-show="errors.has(radioGroupName)"
		   class="help is-danger">
			X
		</span>
	</div>
</template>

<script>
	export default {
		name: 'radio',
		data () {
			return {
				switchFlag: false,
				msg: 'Welcome to Your Vue.js App',
				picked: ''
			}
		},
		computed: {
			radioGroupName(){
				return 'radio'+this._uid
			}
		},
		created() {
			this.switchFlag = _.random(1)==0
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.topcoat-radio-button__checkmark.is-danger:before {
		border-color: #ff3860;
	}
</style>



// WEBPACK FOOTER //
// Radio.vue?77c95d9e